import moment from "moment";
import { Icon, Label } from "semantic-ui-react";

export function LastUpdate({ lastUpdate }) {
  if (!lastUpdate) return null;

  return (
    <Label>
      <Icon name="sync" />
      {`Updated ${moment(lastUpdate).fromNow()}`}
    </Label>
  );
}
